import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  farmerAccountWise: null,
  farmerAccountWiseLoading: false,
  farmerBankWise: null,
  farmerBankWiseLoading: false,
  farmerWarehouseWise: null,
  farmerWarehouseWiseLoading: false,
  procChart: null,
  procChartLoading: false,
  procPaymentPending: null,
  procPaymentPendingLoading: false,
  procPaymentCompleted: null,
  procPaymentCompletedLoading: false,
  procPaymentFailed: null,
  procPaymentFailedLoading: false,
};

export const chartSlice = createSlice({
  name: "chart",
  initialState,
  reducers: {
    setFaremerAccoutWiseLoading: (state, action) => {
      state.farmerAccountWiseLoading = action.payload;
    },
    setFaremerAccoutWise: (state, action) => {
      state.farmerAccountWise = action.payload;
    },
    setFaremerBankWiseLoading: (state, action) => {
      state.farmerBankWiseLoading = action.payload;
    },
    setFaremerBankWise: (state, action) => {
      state.farmerBankWise = [action.payload];
    },
    setFarmerWarehouseWiseLoading: (state, action) => {
      state.farmerWarehouseWiseLoading = action.payload;
    },
    setFarmerWarehouseWise: (state, action) => {
      state.farmerWarehouseWise = action.payload;
    },
    setProcurementLoading: (state, action) => {
      state.procChartLoading = action.payload;
    },
    setProcurement: (state, action) => {
      state.procChart = action.payload;
    },
    setProcurementPendingLoading: (state, action) => {
      state.procPaymentPendingLoading = action.payload;
    },
    setProcurementPending: (state, action) => {
      state.procPaymentPending = action.payload;
    },
    setProcurementCompletedLoading: (state, action) => {
      state.procPaymentCompletedLoading = action.payload;
    },
    setProcurementCompleted: (state, action) => {
      state.procPaymentCompleted = action.payload;
    },
    setProcurementFailedLoading: (state, action) => {
      state.procPaymentFailedLoading = action.payload;
    },
    setProcurementFailed: (state, action) => {
      state.procPaymentFailed = action.payload;
    },
  },
});

export const {
  setFaremerAccoutWise,
  setFaremerAccoutWiseLoading,
  setFaremerBankWise,
  setFaremerBankWiseLoading,
  setFarmerWarehouseWiseLoading,
  setFarmerWarehouseWise,
  setProcurementLoading,
  setProcurement,
  setProcurementPendingLoading,
  setProcurementPending,
  setProcurementCompletedLoading,
  setProcurementCompleted,
  setProcurementFailedLoading,
  setProcurementFailed,
} = chartSlice.actions;

export default chartSlice.reducer;
